import { render, staticRenderFns } from "./ProductShipping.vue?vue&type=template&id=36a384fa&"
import script from "./ProductShipping.vue?vue&type=script&lang=js&"
export * from "./ProductShipping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports